import React from "react";
import { ShieldCheck, Truck, CheckCircle2, Phone } from "lucide-react";
import { company, engineShowcaseImg } from "../mock";
import InlineQuoteForm from "./InlineQuoteForm";

export default function CleanHero() {
  return (
    <section className="hero-light" id="top">
      <div className="hero-watermark" aria-hidden="true" style={{ backgroundImage: `url('${engineShowcaseImg}')` }} />
      <div className="hero-blob b1" />
      <div className="hero-blob b2" />
      <div className="hero-split">
        <div className="hero-split-text">
          <span className="hero-badge">Dal {company.since} · {company.soldPlus} motori venduti</span>
          <h1>Motori usati e rettificati, <span className="accent">garantiti</span></h1>
          <p>
            Trova il motore giusto per la tua auto e ricevi un <strong>preventivo gratuito in giornata</strong>.
            Garanzia 12-24 mesi e spedizione gratuita in tutta Italia.
          </p>
          <div className="hero-light-trust">
            <span><ShieldCheck size={18} /> Garanzia 12-24 mesi</span>
            <span><Truck size={18} /> Spedizione gratuita</span>
            <span><CheckCircle2 size={18} /> Motori testati</span>
          </div>
          <a className="hero-phone" href={`tel:${company.phoneIntl}`}>
            <Phone size={18} /> Chiama ora: {company.phoneDisplay}
          </a>
        </div>
        <div className="hero-split-form">
          <InlineQuoteForm />
        </div>
      </div>
    </section>
  );
}
